import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import {
  useCurrentHomeSiteId,
  useNetworkHomeJobsRouteParams,
} from 'features/networkAi/hooks'
import { siteWlansFetchDataSelector } from 'features/networkAi/selectors'
import { fetchSiteWlansThunk } from 'features/networkAi/slice'
import { SpinnerCentered } from 'components/Loader'
import {
  WLANListHeader,
  WLANListHeaderTitle,
  WLANListLeftBlockPrimary,
  WLANListLeftBlockStatus,
  WLANListBtn,
  WLANListLeftBlock,
  WLANListRightBlock,
} from './styles'
import { SiteWlan } from 'features/networkAi/types'
import WLANsListItem from './WLANsListItem'
import { networkWLANsMessages } from '../messages'

function WLANsList() {
  const { formatMessage } = useIntl()
  const dispatch = useAppDispatch()

  const { homeId } = useNetworkHomeJobsRouteParams()
  const siteWlans = useAppSelector(siteWlansFetchDataSelector.data)
  const isLoading = useAppSelector(siteWlansFetchDataSelector.isFetching)
  const siteId = useCurrentHomeSiteId({ homeId })

  const siteWlansWithNew: SiteWlan[] = Array.isArray(siteWlans)
    ? siteWlans
    : [{} as SiteWlan]

  useEffect(() => {
    siteId && dispatch(fetchSiteWlansThunk(siteId))
  }, [dispatch, siteId])

  return (
    <div key={siteId}>
      <WLANListHeader>
        <WLANListLeftBlockStatus></WLANListLeftBlockStatus>

        <WLANListLeftBlockPrimary>
          <WLANListHeaderTitle>
            {formatMessage(networkWLANsMessages.wlansSSID)}
          </WLANListHeaderTitle>
        </WLANListLeftBlockPrimary>

        <WLANListLeftBlock>
          <WLANListHeaderTitle>
            {formatMessage(networkWLANsMessages.wlansVLANId)}
          </WLANListHeaderTitle>
        </WLANListLeftBlock>
        <WLANListLeftBlock>
          <WLANListHeaderTitle>
            {formatMessage(networkWLANsMessages.wlansBands)}
          </WLANListHeaderTitle>
        </WLANListLeftBlock>
        <WLANListLeftBlock>
          <WLANListHeaderTitle>
            {formatMessage(networkWLANsMessages.wlansSecurity)}
          </WLANListHeaderTitle>
        </WLANListLeftBlock>
        <WLANListLeftBlock>
          <WLANListHeaderTitle>
            {formatMessage(networkWLANsMessages.wlansGuest)}
          </WLANListHeaderTitle>
        </WLANListLeftBlock>
        <WLANListRightBlock>
          <WLANListBtn></WLANListBtn>
        </WLANListRightBlock>
      </WLANListHeader>
      {isLoading ? (
        <SpinnerCentered mt="200px" />
      ) : (
        siteWlans &&
        siteWlansWithNew.map((wlan) => {
          return <WLANsListItem key={wlan.id} wlan={wlan} siteId={siteId} />
        })
      )}
    </div>
  )
}

export default WLANsList
